import { render } from "./CategoriesDropdown.vue?vue&type=template&id=658ea08b"
import script from "./CategoriesDropdown.vue?vue&type=script&lang=js"
export * from "./CategoriesDropdown.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__